import { Banner, Icon, Modal, Typography } from 'glints-aries/es/@next';
import { borderRadius4 } from 'glints-aries/es/@next/utilities/borderRadius';
import { Blue, Neutral, Red } from 'glints-aries/es/@next/utilities/colors';
import {
  space8,
  space12,
  space16,
  space32,
} from 'glints-aries/es/@next/utilities/spacing';
import styled, { css } from 'styled-components';

import { WhatsAppGreen } from '../../../common/color';

const ModalWidthByCountryCode: Record<string, { min: number; max: number }> = {
  ID: {
    min: 1100,
    max: 1100,
  },
  SG: {
    min: 750,
    max: 960,
  },
};

export const StyledModal = styled(Modal)<{ countryCode: string }>`
  .modal-content {
    ${({ countryCode }) => {
      const { min, max } =
        ModalWidthByCountryCode[countryCode.toUpperCase()] ??
        ModalWidthByCountryCode.ID;
      return css`
        min-width: ${min}px;
        max-width: ${max}px;
      `;
    }}

    width: 100%;
    padding: 0;
  }

  .card-container {
    box-shadow: rgba(63, 63, 68, 0.05) 0px 0px 0px 1px;
  }
`;
export const StyledLoadingModal = styled(StyledModal)`
  .modal-content {
    height: 500px;
    display: flex;
    padding: 0;
    justify-content: center;
    align-items: center;
  }
`;
export const PaddedContainer = styled.div`
  padding: 0 20px;
`;

export const VerificationModalBanner = styled(Banner)`
  min-height: unset;
`;

export const TypographyWithBulletPoint = styled(Typography)`
  display: flex;
  column-gap: ${space8};
  ::before {
    content: '\u2022';
    padding-inline-start: 10px;
  }
`;

export const VerificationMethodCardStyles = {
  Container: styled.div`
    border: 1px solid ${Neutral.B85};
    border-radius: ${space8};
    display: flex;
    flex-direction: column;
    gap: ${space12};
    padding: 20px;
    position: relative;
    flex: 1;
    cursor: pointer;

    &[data-active='true'] {
      border-color: ${Blue.S99};
      background-color: ${Blue.S08};
    }

    &[data-view-only='true'] {
      flex-direction: row;
      gap: 20px;
      cursor: default;
    }

    &[data-disabled='true'] {
      cursor: default;
      pointer-events: none;
      opacity: 0.5;
    }
  `,
  Icon: styled(Icon)`
    width: 40px;
    height: 40px;
    fill: ${Neutral.B40};

    &[data-active='true'] {
      fill: ${Blue.S99};
    }

    &[data-view-only='true'] {
      display: none;
    }
  `,
  DividerContainer: styled.div`
    display: flex;
    align-items: center;
    gap: ${space12};

    &[data-view-only='true'] {
      p {
        display: none;
      }
      & > div:first-child {
        display: none;
      }
      & > div:last-child {
        height: 100%;
        width: 1px;
      }
    }
  `,
  TagContainer: styled.div`
    position: absolute;
    display: flex;
    margin: 0 auto;
    left: 20px;
    right: 0;
    top: -10px;
    min-width: fit-content;
    z-index: 1;
  `,
  BenefitsContainer: styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: row;
    gap: ${space32};
    p {
      white-space: nowrap;
    }
  `,
};

export const FormContentStyles = {
  VisibilityContainer: styled.div<{
    visible: boolean;
  }>`
    display: ${props => (props.visible ? 'block' : 'none')};
  `,
  BackgroundContainer: styled.div`
    background-color: ${Neutral.B99};
  `,
  Container: styled.div`
    padding: 20px;
    display: flex;
    align-items: flex-start;
    gap: 20px;

    .section {
      padding: 20px;
    }
  `,
  TypographyWithBulletPoint: TypographyWithBulletPoint,
  FullWidthCardContainer: styled.div`
    flex: 1;
    min-width: 652px;
  `,
  Asterisk: styled.span`
    ::before {
      color: ${Red.B93};
      content: '*';
    }
  `,
  WhatsAppVerificationStatusContainer: styled.div`
    padding: ${space16};
    background-color: ${Neutral.B99};

    button > svg {
      fill: ${WhatsAppGreen};
    }
  `,
  RequiredSectionContainer: styled.div`
    .card-container {
      min-width: 360px;
      max-width: 360px;
    }
    .section {
      padding: 20px;
    }
  `,
  RequiredSectionItem: styled.div`
    display: flex;
    flex-direction: row;
    gap: ${space8};
    padding-bottom: ${space12};
    border-bottom: 1px solid ${Neutral.B95};
    &:last-child {
      border-bottom: none;
    }
  `,
  TutorialCard: styled.div`
    background-color: ${Neutral.B99};
    width: 100%;
    height: fit-content;
    border-radius: ${borderRadius4};
    display: flex;
    flex-direction: row;
    gap: ${space16};
    padding: ${space12} ${space16};
    cursor: pointer;
    border: 1px solid ${Neutral.B85};

    &[data-disabled='true'] {
      cursor: default;
      pointer-events: none;
      opacity: 0.5;
    }
  `,
};

export const StyledButtonGroupFooterWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledLeftButtonWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const StyledRightButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;
